
export default function SecuritySection() {
  const securityFeatures = [
    {
      icon: 'ri-fingerprint-line',
      title: 'Biometric Lock',
      description: 'Secure your wallet with Face ID or fingerprint authentication.',
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Local Key Storage',
      description: 'Your private keys are encrypted and stored only on your device.',
    },
    {
      icon: 'ri-file-shield-2-line',
      title: 'Backup & Recovery',
      description: 'Secure recovery phrase to restore your wallet. Never share it with anyone.',
    },
    {
      icon: 'ri-cloud-off-line',
      title: 'No Server Storage',
      description: 'Your private keys never leave your device. We can\'t access them.',
    },
  ];

  return (
    <section id="security" className="py-16 lg:py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
          {/* Left Content */}
          <div className="flex-1">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
              Security first. Always.
            </h2>
            <p className="text-lg text-gray-300 mb-8 leading-relaxed">
              Vollet is a non-custodial wallet, which means you – and only you – control your crypto. 
              Your private keys are encrypted and stored locally on your device, protected by 
              industry-standard security measures and your device's biometric authentication.
            </p>
            <div className="inline-flex items-center gap-2 bg-[#00D0A3]/20 text-[#00D0A3] px-4 py-2 rounded-full">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-shield-check-line text-lg"></i>
              </div>
              <span className="text-sm font-medium">Vollet never stores your private keys</span>
            </div>
          </div>

          {/* Right Content - Security Cards */}
          <div className="flex-1 w-full">
            <div className="space-y-4">
              {securityFeatures.map((feature, index) => (
                <div
                  key={index}
                  className="bg-gray-800 rounded-xl p-5 hover:bg-gray-750 transition-colors cursor-pointer group border border-gray-700"
                >
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-[#4C6FFF]/20 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-[#4C6FFF]/30 transition-colors">
                      <i className={`${feature.icon} text-lg text-[#4C6FFF]`}></i>
                    </div>
                    <div>
                      <h3 className="text-white font-semibold mb-1">{feature.title}</h3>
                      <p className="text-gray-400 text-sm leading-relaxed">{feature.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
